export const getPercent = (num1: number, num2: number) => {
  if (num1 > num2) return 100;
  return Math.round((num1 / num2) * 100);
};
